module.exports = __webpack_public_path__ + "static/media/truck-advantages.5b0ec5c3.png";